import { PricingHeader } from '@aibees/shared/features/price-and-plan/components/pricing-header';
import { Box } from '@mui/material';
import { type MouseEventHandler, useRef } from 'react';
import { CollapsedTable } from './components/collapsed-table';
import { CreditUsageOverview } from './components/credit-usage-overview';
import * as Styled from './styles';

export function PriceAndPlan() {
  const comparisonRef = useRef<HTMLDivElement>(null);

  const handleScrollToComparison: MouseEventHandler<HTMLDivElement> = (e) => {
    if (
      comparisonRef.current &&
      (e.target as HTMLElement).getAttribute('rel')
    ) {
      comparisonRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <Styled.Wrapper onClick={handleScrollToComparison}>
        <PricingHeader />
        <CreditUsageOverview />
        <Box ref={comparisonRef}>
          <CollapsedTable />
        </Box>
        {/* <PlanDetail /> */}
        {/* <ClientsComments /> */}
      </Styled.Wrapper>
      {/* <Faq /> */}
    </>
  );
}
